//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClientBase {
  protected transformOptions(options: RequestInit): Promise<RequestInit> {
    const token = window.localStorage.getItem("tenfour.access_token");
    if (token) {
      options.headers = {
        ...(options.headers as Record<string, string>),
        Authorization: `Bearer ${token}`,
      };
    }
    return Promise.resolve(options);
  }
}

export interface IAudiencesClient {

    audiences_Schema(): Promise<AudienceSchemaDescription>;

    audiences_Preview(request: PreviewRequest): Promise<AudiencePreview>;

    audiences_Explain(request: ExplainRequest): Promise<AudienceExplanation>;

    audiences_ListGroups(): Promise<AudienceGroupSummary[]>;

    audiences_UpsertGroup(key: string, request: UpsertGroupRequest): Promise<AudienceGroupSummary>;

    audiences_DeleteGroup(key: string): Promise<FileResponse>;

    audiences_ListNodes(): Promise<NodeSummary[]>;

    audiences_UpsertNode(key: string, request: UpsertNodeRequest): Promise<NodeSummary>;

    audiences_DeleteNode(key: string): Promise<FileResponse>;
}

export class AudiencesClient extends ApiClientBase implements IAudiencesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    audiences_Schema(): Promise<AudienceSchemaDescription> {
        let url_ = this.baseUrl + "/api/audiences/schema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_Schema(_response);
        });
    }

    protected processAudiences_Schema(response: Response): Promise<AudienceSchemaDescription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AudienceSchemaDescription;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AudienceSchemaDescription>(null as any);
    }

    audiences_Preview(request: PreviewRequest): Promise<AudiencePreview> {
        let url_ = this.baseUrl + "/api/audiences/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_Preview(_response);
        });
    }

    protected processAudiences_Preview(response: Response): Promise<AudiencePreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AudiencePreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AudiencePreview>(null as any);
    }

    audiences_Explain(request: ExplainRequest): Promise<AudienceExplanation> {
        let url_ = this.baseUrl + "/api/audiences/explain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_Explain(_response);
        });
    }

    protected processAudiences_Explain(response: Response): Promise<AudienceExplanation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AudienceExplanation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AudienceExplanation>(null as any);
    }

    audiences_ListGroups(): Promise<AudienceGroupSummary[]> {
        let url_ = this.baseUrl + "/api/audiences/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_ListGroups(_response);
        });
    }

    protected processAudiences_ListGroups(response: Response): Promise<AudienceGroupSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AudienceGroupSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AudienceGroupSummary[]>(null as any);
    }

    audiences_UpsertGroup(key: string, request: UpsertGroupRequest): Promise<AudienceGroupSummary> {
        let url_ = this.baseUrl + "/api/audiences/groups/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_UpsertGroup(_response);
        });
    }

    protected processAudiences_UpsertGroup(response: Response): Promise<AudienceGroupSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AudienceGroupSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AudienceGroupSummary>(null as any);
    }

    audiences_DeleteGroup(key: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/audiences/groups/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_DeleteGroup(_response);
        });
    }

    protected processAudiences_DeleteGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    audiences_ListNodes(): Promise<NodeSummary[]> {
        let url_ = this.baseUrl + "/api/audiences/nodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_ListNodes(_response);
        });
    }

    protected processAudiences_ListNodes(response: Response): Promise<NodeSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NodeSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NodeSummary[]>(null as any);
    }

    audiences_UpsertNode(key: string, request: UpsertNodeRequest): Promise<NodeSummary> {
        let url_ = this.baseUrl + "/api/audiences/nodes/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_UpsertNode(_response);
        });
    }

    protected processAudiences_UpsertNode(response: Response): Promise<NodeSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NodeSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NodeSummary>(null as any);
    }

    audiences_DeleteNode(key: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/audiences/nodes/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudiences_DeleteNode(_response);
        });
    }

    protected processAudiences_DeleteNode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAuditClient {

    audit_List(from?: string | null | undefined, to?: string | null | undefined, actor?: string | null | undefined, action?: string | null | undefined, entityType?: string | null | undefined, entityId?: string | null | undefined, limit?: number | undefined, offset?: number | undefined): Promise<AuditPage>;
}

export class AuditClient extends ApiClientBase implements IAuditClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    audit_List(from?: string | null | undefined, to?: string | null | undefined, actor?: string | null | undefined, action?: string | null | undefined, entityType?: string | null | undefined, entityId?: string | null | undefined, limit?: number | undefined, offset?: number | undefined): Promise<AuditPage> {
        let url_ = this.baseUrl + "/api/audit?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (actor !== undefined && actor !== null)
            url_ += "actor=" + encodeURIComponent("" + actor) + "&";
        if (action !== undefined && action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        if (entityType !== undefined && entityType !== null)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAudit_List(_response);
        });
    }

    protected processAudit_List(response: Response): Promise<AuditPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditPage>(null as any);
    }
}

export interface IAuthClient {

    auth_Login(request: LoginRequest): Promise<TokenResponse>;

    auth_Refresh(request: RefreshRequest): Promise<TokenResponse>;

    auth_Logout(): Promise<FileResponse>;

    auth_ChangePassword(request: ChangePasswordRequest): Promise<FileResponse>;
}

export class AuthClient extends ApiClientBase implements IAuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    auth_Login(request: LoginRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuth_Login(_response);
        });
    }

    protected processAuth_Login(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    auth_Refresh(request: RefreshRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuth_Refresh(_response);
        });
    }

    protected processAuth_Refresh(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    auth_Logout(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuth_Logout(_response);
        });
    }

    protected processAuth_Logout(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    auth_ChangePassword(request: ChangePasswordRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuth_ChangePassword(_response);
        });
    }

    protected processAuth_ChangePassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISessionClient {

    session_Context(): Promise<SessionContext>;
}

export class SessionClient extends ApiClientBase implements ISessionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    session_Context(): Promise<SessionContext> {
        let url_ = this.baseUrl + "/api/session/context";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSession_Context(_response);
        });
    }

    protected processSession_Context(response: Response): Promise<SessionContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionContext>(null as any);
    }
}

export interface IHealthClient {

    health_Get(): Promise<FileResponse>;
}

export class HealthClient extends ApiClientBase implements IHealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    health_Get(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealth_Get(_response);
        });
    }

    protected processHealth_Get(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMessagesClient {

    messages_Publish(request: PublishRequest): Promise<PublishResponse>;

    messages_List(stream?: string | null | undefined, subject?: string | null | undefined, limit?: number | undefined): Promise<MessageListItem[]>;

    messages_Search(query?: string | null | undefined, stream?: string | null | undefined, limit?: number | undefined): Promise<MessageListItem[]>;

    messages_Trace(id: string): Promise<MessageTrace>;

    messages_Tracking(id: string): Promise<ReadTrackingReport>;

    messages_Receipt(id: string, request: ReceiptRequest): Promise<FileResponse>;

    messages_Dismiss(id: string): Promise<FileResponse>;

    messages_Reply(id: string, request: ReplyRequest): Promise<PublishResponse>;

    messages_Thread(id: string): Promise<MessageView[]>;
}

export class MessagesClient extends ApiClientBase implements IMessagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    messages_Publish(request: PublishRequest): Promise<PublishResponse> {
        let url_ = this.baseUrl + "/api/messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Publish(_response);
        });
    }

    protected processMessages_Publish(response: Response): Promise<PublishResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublishResponse;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublishResponse;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublishResponse>(null as any);
    }

    messages_List(stream?: string | null | undefined, subject?: string | null | undefined, limit?: number | undefined): Promise<MessageListItem[]> {
        let url_ = this.baseUrl + "/api/messages?";
        if (stream !== undefined && stream !== null)
            url_ += "stream=" + encodeURIComponent("" + stream) + "&";
        if (subject !== undefined && subject !== null)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_List(_response);
        });
    }

    protected processMessages_List(response: Response): Promise<MessageListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageListItem[]>(null as any);
    }

    messages_Search(query?: string | null | undefined, stream?: string | null | undefined, limit?: number | undefined): Promise<MessageListItem[]> {
        let url_ = this.baseUrl + "/api/messages/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (stream !== undefined && stream !== null)
            url_ += "stream=" + encodeURIComponent("" + stream) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Search(_response);
        });
    }

    protected processMessages_Search(response: Response): Promise<MessageListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageListItem[]>(null as any);
    }

    messages_Trace(id: string): Promise<MessageTrace> {
        let url_ = this.baseUrl + "/api/messages/{id}/trace";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Trace(_response);
        });
    }

    protected processMessages_Trace(response: Response): Promise<MessageTrace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageTrace;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTrace>(null as any);
    }

    messages_Tracking(id: string): Promise<ReadTrackingReport> {
        let url_ = this.baseUrl + "/api/messages/{id}/tracking";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Tracking(_response);
        });
    }

    protected processMessages_Tracking(response: Response): Promise<ReadTrackingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReadTrackingReport;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadTrackingReport>(null as any);
    }

    messages_Receipt(id: string, request: ReceiptRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/messages/{id}/receipt";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Receipt(_response);
        });
    }

    protected processMessages_Receipt(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    messages_Dismiss(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/messages/{id}/dismiss";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Dismiss(_response);
        });
    }

    protected processMessages_Dismiss(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    messages_Reply(id: string, request: ReplyRequest): Promise<PublishResponse> {
        let url_ = this.baseUrl + "/api/messages/{id}/reply";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Reply(_response);
        });
    }

    protected processMessages_Reply(response: Response): Promise<PublishResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublishResponse;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublishResponse>(null as any);
    }

    messages_Thread(id: string): Promise<MessageView[]> {
        let url_ = this.baseUrl + "/api/messages/{id}/thread";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessages_Thread(_response);
        });
    }

    protected processMessages_Thread(response: Response): Promise<MessageView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageView[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageView[]>(null as any);
    }
}

export interface IConsumerClient {

    consumer_Inbox(since?: number | null | undefined, wait?: number | undefined, limit?: number | undefined): Promise<InboxResponse>;

    consumer_Cursor(limit?: number | undefined): Promise<CursorResponse>;

    consumer_CommitCursor(request: CommitCursorRequest): Promise<FileResponse>;
}

export class ConsumerClient extends ApiClientBase implements IConsumerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    consumer_Inbox(since?: number | null | undefined, wait?: number | undefined, limit?: number | undefined): Promise<InboxResponse> {
        let url_ = this.baseUrl + "/api/inbox?";
        if (since !== undefined && since !== null)
            url_ += "since=" + encodeURIComponent("" + since) + "&";
        if (wait === null)
            throw new globalThis.Error("The parameter 'wait' cannot be null.");
        else if (wait !== undefined)
            url_ += "wait=" + encodeURIComponent("" + wait) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumer_Inbox(_response);
        });
    }

    protected processConsumer_Inbox(response: Response): Promise<InboxResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InboxResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InboxResponse>(null as any);
    }

    consumer_Cursor(limit?: number | undefined): Promise<CursorResponse> {
        let url_ = this.baseUrl + "/api/cursor?";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumer_Cursor(_response);
        });
    }

    protected processConsumer_Cursor(response: Response): Promise<CursorResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CursorResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CursorResponse>(null as any);
    }

    consumer_CommitCursor(request: CommitCursorRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/cursor/commit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumer_CommitCursor(_response);
        });
    }

    protected processConsumer_CommitCursor(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPartiesClient {

    parties_List(type?: string | null | undefined, search?: string | null | undefined): Promise<PartySummary[]>;

    parties_Get(key: string): Promise<PartySummary>;

    parties_Upsert(key: string, request: UpsertPartyRequest): Promise<PartySummary>;

    parties_Delete(key: string): Promise<FileResponse>;

    parties_SetNode(key: string, request: SetPartyNodeRequest): Promise<PartySummary>;

    parties_ListAttributeDefinitions(): Promise<AttributeDefinitionSummary[]>;

    parties_UpsertAttributeDefinition(key: string, request: UpsertAttributeDefinitionRequest): Promise<AttributeDefinitionSummary>;

    parties_SyncAttributes(sourceSystem: string, partyAttributes: { [key: string]: { [key: string]: string[]; }; }): Promise<FileResponse>;
}

export class PartiesClient extends ApiClientBase implements IPartiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    parties_List(type?: string | null | undefined, search?: string | null | undefined): Promise<PartySummary[]> {
        let url_ = this.baseUrl + "/api/parties?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_List(_response);
        });
    }

    protected processParties_List(response: Response): Promise<PartySummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartySummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartySummary[]>(null as any);
    }

    parties_Get(key: string): Promise<PartySummary> {
        let url_ = this.baseUrl + "/api/parties/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_Get(_response);
        });
    }

    protected processParties_Get(response: Response): Promise<PartySummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartySummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartySummary>(null as any);
    }

    parties_Upsert(key: string, request: UpsertPartyRequest): Promise<PartySummary> {
        let url_ = this.baseUrl + "/api/parties/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_Upsert(_response);
        });
    }

    protected processParties_Upsert(response: Response): Promise<PartySummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartySummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartySummary>(null as any);
    }

    parties_Delete(key: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/parties/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_Delete(_response);
        });
    }

    protected processParties_Delete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    parties_SetNode(key: string, request: SetPartyNodeRequest): Promise<PartySummary> {
        let url_ = this.baseUrl + "/api/parties/{key}/node";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_SetNode(_response);
        });
    }

    protected processParties_SetNode(response: Response): Promise<PartySummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartySummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartySummary>(null as any);
    }

    parties_ListAttributeDefinitions(): Promise<AttributeDefinitionSummary[]> {
        let url_ = this.baseUrl + "/api/attribute-definitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_ListAttributeDefinitions(_response);
        });
    }

    protected processParties_ListAttributeDefinitions(response: Response): Promise<AttributeDefinitionSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttributeDefinitionSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttributeDefinitionSummary[]>(null as any);
    }

    parties_UpsertAttributeDefinition(key: string, request: UpsertAttributeDefinitionRequest): Promise<AttributeDefinitionSummary> {
        let url_ = this.baseUrl + "/api/attribute-definitions/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_UpsertAttributeDefinition(_response);
        });
    }

    protected processParties_UpsertAttributeDefinition(response: Response): Promise<AttributeDefinitionSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttributeDefinitionSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttributeDefinitionSummary>(null as any);
    }

    parties_SyncAttributes(sourceSystem: string, partyAttributes: { [key: string]: { [key: string]: string[]; }; }): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/attribute-sync/{sourceSystem}";
        if (sourceSystem === undefined || sourceSystem === null)
            throw new globalThis.Error("The parameter 'sourceSystem' must be defined.");
        url_ = url_.replace("{sourceSystem}", encodeURIComponent("" + sourceSystem));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partyAttributes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParties_SyncAttributes(_response);
        });
    }

    protected processParties_SyncAttributes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPrincipalsClient {

    principals_List(type?: string | null | undefined): Promise<PrincipalSummary[]>;

    principals_Create(request: CreateUserRequest): Promise<PrincipalSummary>;

    principals_Get(id: string): Promise<PrincipalSummary>;

    principals_SetParty(id: string, request: SetPrincipalPartyRequest): Promise<PrincipalSummary>;

    principals_InboxBinding(id: string): Promise<InboxBinding>;

    principals_SetAccess(id: string, module: string, request: SetModuleAccessRequest): Promise<FileResponse>;

    principals_SetActive(id: string, request: SetActiveRequest): Promise<FileResponse>;

    principals_SetGrants(id: string, request: SetGrantsRequest): Promise<FileResponse>;

    principals_SetAudienceScope(id: string, request: SetAudienceScopeRequest): Promise<FileResponse>;

    principals_Modules(): Promise<FileResponse>;
}

export class PrincipalsClient extends ApiClientBase implements IPrincipalsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    principals_List(type?: string | null | undefined): Promise<PrincipalSummary[]> {
        let url_ = this.baseUrl + "/api/principals?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_List(_response);
        });
    }

    protected processPrincipals_List(response: Response): Promise<PrincipalSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalSummary[]>(null as any);
    }

    principals_Create(request: CreateUserRequest): Promise<PrincipalSummary> {
        let url_ = this.baseUrl + "/api/principals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_Create(_response);
        });
    }

    protected processPrincipals_Create(response: Response): Promise<PrincipalSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalSummary;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalSummary>(null as any);
    }

    principals_Get(id: string): Promise<PrincipalSummary> {
        let url_ = this.baseUrl + "/api/principals/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_Get(_response);
        });
    }

    protected processPrincipals_Get(response: Response): Promise<PrincipalSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalSummary>(null as any);
    }

    principals_SetParty(id: string, request: SetPrincipalPartyRequest): Promise<PrincipalSummary> {
        let url_ = this.baseUrl + "/api/principals/{id}/party";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_SetParty(_response);
        });
    }

    protected processPrincipals_SetParty(response: Response): Promise<PrincipalSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalSummary>(null as any);
    }

    principals_InboxBinding(id: string): Promise<InboxBinding> {
        let url_ = this.baseUrl + "/api/principals/{id}/inbox-binding";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_InboxBinding(_response);
        });
    }

    protected processPrincipals_InboxBinding(response: Response): Promise<InboxBinding> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InboxBinding;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InboxBinding>(null as any);
    }

    principals_SetAccess(id: string, module: string, request: SetModuleAccessRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/principals/{id}/access/{module}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (module === undefined || module === null)
            throw new globalThis.Error("The parameter 'module' must be defined.");
        url_ = url_.replace("{module}", encodeURIComponent("" + module));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_SetAccess(_response);
        });
    }

    protected processPrincipals_SetAccess(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    principals_SetActive(id: string, request: SetActiveRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/principals/{id}/active";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_SetActive(_response);
        });
    }

    protected processPrincipals_SetActive(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    principals_SetGrants(id: string, request: SetGrantsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/principals/{id}/grants";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_SetGrants(_response);
        });
    }

    protected processPrincipals_SetGrants(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    principals_SetAudienceScope(id: string, request: SetAudienceScopeRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/principals/{id}/audience-scope";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_SetAudienceScope(_response);
        });
    }

    protected processPrincipals_SetAudienceScope(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    principals_Modules(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrincipals_Modules(_response);
        });
    }

    protected processPrincipals_Modules(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IApiKeysClient {

    apiKeys_List(): Promise<ApiKeySummary[]>;

    apiKeys_Create(request: CreateApiKeyRequest): Promise<CreatedApiKey>;

    apiKeys_Rotate(principalId: string, request: RotateApiKeyRequest): Promise<CreatedApiKey>;

    apiKeys_Revoke(principalId: string): Promise<FileResponse>;
}

export class ApiKeysClient extends ApiClientBase implements IApiKeysClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    apiKeys_List(): Promise<ApiKeySummary[]> {
        let url_ = this.baseUrl + "/api/api-keys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiKeys_List(_response);
        });
    }

    protected processApiKeys_List(response: Response): Promise<ApiKeySummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiKeySummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeySummary[]>(null as any);
    }

    apiKeys_Create(request: CreateApiKeyRequest): Promise<CreatedApiKey> {
        let url_ = this.baseUrl + "/api/api-keys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiKeys_Create(_response);
        });
    }

    protected processApiKeys_Create(response: Response): Promise<CreatedApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedApiKey;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedApiKey>(null as any);
    }

    apiKeys_Rotate(principalId: string, request: RotateApiKeyRequest): Promise<CreatedApiKey> {
        let url_ = this.baseUrl + "/api/api-keys/{principalId}/rotate";
        if (principalId === undefined || principalId === null)
            throw new globalThis.Error("The parameter 'principalId' must be defined.");
        url_ = url_.replace("{principalId}", encodeURIComponent("" + principalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiKeys_Rotate(_response);
        });
    }

    protected processApiKeys_Rotate(response: Response): Promise<CreatedApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedApiKey;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedApiKey>(null as any);
    }

    apiKeys_Revoke(principalId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/api-keys/{principalId}";
        if (principalId === undefined || principalId === null)
            throw new globalThis.Error("The parameter 'principalId' must be defined.");
        url_ = url_.replace("{principalId}", encodeURIComponent("" + principalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiKeys_Revoke(_response);
        });
    }

    protected processApiKeys_Revoke(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITenantsClient {

    tenants_List(): Promise<TenantSummary[]>;

    tenants_Create(request: CreateTenantRequest): Promise<CreatedTenant>;

    tenants_SetActive(id: string, request: SetActiveRequest): Promise<TenantSummary>;
}

export class TenantsClient extends ApiClientBase implements ITenantsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    tenants_List(): Promise<TenantSummary[]> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenants_List(_response);
        });
    }

    protected processTenants_List(response: Response): Promise<TenantSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantSummary[]>(null as any);
    }

    tenants_Create(request: CreateTenantRequest): Promise<CreatedTenant> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenants_Create(_response);
        });
    }

    protected processTenants_Create(response: Response): Promise<CreatedTenant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedTenant;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedTenant>(null as any);
    }

    tenants_SetActive(id: string, request: SetActiveRequest): Promise<TenantSummary> {
        let url_ = this.baseUrl + "/api/tenants/{id}/active";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenants_SetActive(_response);
        });
    }

    protected processTenants_SetActive(response: Response): Promise<TenantSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantSummary>(null as any);
    }
}

export interface IStreamsClient {

    streams_List(): Promise<StreamSummary[]>;

    streams_Upsert(key: string, request: UpsertStreamRequest): Promise<StreamSummary>;

    streams_UpsertSubject(key: string, subject: string, request: UpsertSubjectRequest): Promise<SubjectSummary>;
}

export class StreamsClient extends ApiClientBase implements IStreamsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    streams_List(): Promise<StreamSummary[]> {
        let url_ = this.baseUrl + "/api/streams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStreams_List(_response);
        });
    }

    protected processStreams_List(response: Response): Promise<StreamSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StreamSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StreamSummary[]>(null as any);
    }

    streams_Upsert(key: string, request: UpsertStreamRequest): Promise<StreamSummary> {
        let url_ = this.baseUrl + "/api/streams/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStreams_Upsert(_response);
        });
    }

    protected processStreams_Upsert(response: Response): Promise<StreamSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StreamSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StreamSummary>(null as any);
    }

    streams_UpsertSubject(key: string, subject: string, request: UpsertSubjectRequest): Promise<SubjectSummary> {
        let url_ = this.baseUrl + "/api/streams/{key}/subjects/{subject}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (subject === undefined || subject === null)
            throw new globalThis.Error("The parameter 'subject' must be defined.");
        url_ = url_.replace("{subject}", encodeURIComponent("" + subject));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStreams_UpsertSubject(_response);
        });
    }

    protected processStreams_UpsertSubject(response: Response): Promise<SubjectSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubjectSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectSummary>(null as any);
    }
}

export interface IMessageFlagsClient {

    messageFlags_List(): Promise<FlagAdminSummary[]>;

    messageFlags_Upsert(key: string, request: UpsertFlagRequest): Promise<FlagAdminSummary>;

    messageFlags_Delete(key: string): Promise<FileResponse>;
}

export class MessageFlagsClient extends ApiClientBase implements IMessageFlagsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    messageFlags_List(): Promise<FlagAdminSummary[]> {
        let url_ = this.baseUrl + "/api/message-flags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessageFlags_List(_response);
        });
    }

    protected processMessageFlags_List(response: Response): Promise<FlagAdminSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagAdminSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlagAdminSummary[]>(null as any);
    }

    messageFlags_Upsert(key: string, request: UpsertFlagRequest): Promise<FlagAdminSummary> {
        let url_ = this.baseUrl + "/api/message-flags/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessageFlags_Upsert(_response);
        });
    }

    protected processMessageFlags_Upsert(response: Response): Promise<FlagAdminSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagAdminSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlagAdminSummary>(null as any);
    }

    messageFlags_Delete(key: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/message-flags/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMessageFlags_Delete(_response);
        });
    }

    protected processMessageFlags_Delete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISubscriptionsClient {

    subscriptions_List(mode?: string | null | undefined, includeInactive?: boolean | undefined): Promise<SubscriptionSummary[]>;
}

export class SubscriptionsClient extends ApiClientBase implements ISubscriptionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5080";
    }

    subscriptions_List(mode?: string | null | undefined, includeInactive?: boolean | undefined): Promise<SubscriptionSummary[]> {
        let url_ = this.baseUrl + "/api/subscriptions?";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubscriptions_List(_response);
        });
    }

    protected processSubscriptions_List(response: Response): Promise<SubscriptionSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionSummary[]>(null as any);
    }
}

export interface AudienceSchemaDescription {
    attributes?: AttributeDefinitionSummary[];
    groups?: AudienceGroupSummary[];
    nodes?: NodeSummary[];
    partyTypes?: string[];
    channels?: string[];
    flags?: FlagSummary[];
}

export interface AttributeDefinitionSummary {
    id?: string;
    key?: string;
    displayName?: string;
    dataType?: string;
    cardinality?: string;
    allowedValues?: string[] | undefined;
    isFilterable?: boolean;
    description?: string | undefined;
    source?: string;
    sourceSystem?: string | undefined;
    stalenessThresholdSeconds?: number | undefined;
    lastSyncedAt?: string | undefined;
    isStale?: boolean;
}

export interface AudienceGroupSummary {
    id?: string;
    key?: string;
    name?: string;
    kind?: string;
    description?: string | undefined;
    memberCount?: number;
    lastRefreshedAt?: string | undefined;
    expression?: AudienceExpression | undefined;
}

export interface AudienceExpression {
    include?: AudienceTerm[];
    require?: AudienceTerm[];
    exclude?: AudienceTerm[];
    isEmpty?: boolean;
}

export interface AudienceTerm {
    all?: AllTerm | undefined;
    where?: { [key: string]: string[]; } | undefined;
    under?: string | undefined;
    party_type?: string | undefined;
    group?: string | undefined;
    parties?: string[] | undefined;
    self?: boolean | undefined;
}

export interface AllTerm {
    party_type?: string;
}

export interface NodeSummary {
    id?: string;
    key?: string;
    name?: string;
    parentKey?: string | undefined;
    depth?: number;
    childCount?: number;
    partyCount?: number;
}

export interface FlagSummary {
    key?: string;
    displayName?: string;
    colorHint?: string | undefined;
    description?: string | undefined;
    isPlatform?: boolean;
}

export interface AudiencePreview {
    count?: number;
    sample?: PreviewedParty[];
    warnings?: AudienceWarning[];
    freshness?: AttributeFreshness[];
}

export interface PreviewedParty {
    id?: string;
    key?: string;
    type?: string;
    name?: string;
    channels?: string[];
}

export interface AudienceWarning {
    code?: string;
    message?: string;
    detail?: string | undefined;
}

export interface AttributeFreshness {
    key?: string;
    source?: string;
    lastSyncedAt?: string | undefined;
    isStale?: boolean;
    label?: string;
}

export interface PreviewRequest {
    audience?: AudienceExpression;
    channels?: string[] | undefined;
    sampleSize?: number | undefined;
}

export interface AudienceExplanation {
    partyKey?: string;
    included?: boolean;
    matchedTerm?: string | undefined;
    matchedKey?: string | undefined;
    responsibleClause?: string | undefined;
    responsibleTerm?: string | undefined;
    partyKeys?: string[];
    evaluations?: TermEvaluation[];
}

export interface TermEvaluation {
    clause?: string;
    termNo?: number;
    term?: string;
    matched?: boolean;
    missingFacets?: string[];
}

export interface ExplainRequest {
    audience?: AudienceExpression;
    partyKey?: string;
}

export interface UpsertGroupRequest {
    key?: string;
    name?: string;
    kind?: string;
    description?: string | undefined;
    partyKeys?: string[] | undefined;
    expression?: AudienceExpression | undefined;
}

export interface UpsertNodeRequest {
    name?: string;
    parentKey?: string | undefined;
}

export interface AuditPage {
    events?: AuditEventView[];
    limit?: number;
    offset?: number;
    hasMore?: boolean;
}

export interface AuditEventView {
    id?: number;
    occurredAt?: string;
    principalId?: string | undefined;
    principalName?: string;
    action?: string;
    entityType?: string;
    entityId?: string | undefined;
    data?: string | undefined;
    ipAddress?: string | undefined;
}

export interface TokenResponse {
    accessToken?: string;
    refreshToken?: string;
    expiresAt?: string;
}

export interface LoginRequest {
    email?: string;
    password?: string;
}

export interface RefreshRequest {
    refreshToken?: string;
}

export interface ChangePasswordRequest {
    currentPassword?: string;
    newPassword?: string;
}

export interface SessionContext {
    user?: SessionUser;
    modules?: { [key: string]: ModuleAccess; };
    scope?: SessionScope;
}

export interface SessionUser {
    id?: string;
    name?: string;
    email?: string | undefined;
}

export interface ModuleAccess {
    level?: AccessLevel;
    capabilities?: string[];
}

export type AccessLevel = "NONE" | "READ" | "WRITE" | "ADMIN";

export interface SessionScope {
    principal_type?: string;
    tenant?: TenantRef | undefined;
    platform_admin?: boolean;
    party?: PartyRef | undefined;
    grants?: GrantRef[];
    max_audience_scope?: string;
    audience_groups?: string[];
    channel?: string | undefined;
}

export interface TenantRef {
    id?: string;
    name?: string;
}

export interface PartyRef {
    id?: string;
    type?: string;
    name?: string;
    key?: string;
}

export interface GrantRef {
    pattern?: string;
    rights?: string[];
}

export interface PublishResponse {
    id?: string;
    sequence?: number;
    correlationId?: string;
    audienceSize?: number;
    deduplicated?: boolean;
    warnings?: AudienceWarning[];
}

export interface PublishRequest {
    stream?: string;
    subject?: string;
    occurredAt?: string | undefined;
    expiresAt?: string | undefined;
    dueAt?: string | undefined;
    severity?: string;
    flags?: string[];
    pinnedUntil?: string | undefined;
    idempotencyKey?: string | undefined;
    headers?: { [key: string]: string; } | undefined;
    audience?: AudienceExpression;
    channels?: string[];
    requiresAcknowledgement?: boolean;
    allowsReply?: boolean;
    payload?: any | undefined;
    presentation?: Presentation | undefined;
    attachments?: any[];
}

export interface Presentation {
    title?: string | undefined;
    body?: string | undefined;
    actions?: PresentationAction[];
}

export interface PresentationAction {
    label?: string;
    url?: string;
}

export interface MessageListItem {
    id?: string;
    sequence?: number;
    stream?: string;
    subject?: string;
    publishedAt?: string;
    expiresAt?: string | undefined;
    dueAt?: string | undefined;
    severity?: string;
    flags?: string[];
    requiresAcknowledgement?: boolean;
    allowsReply?: boolean;
    producerName?: string;
    audienceAtPublish?: number;
    readCount?: number;
    acknowledgedCount?: number;
    title?: string | undefined;
}

export interface MessageTrace {
    summary?: MessageListItem;
    audience?: AudienceExpression;
    channels?: string[];
    terms?: TermRow[];
    warnings?: AudienceWarning[];
    tracking?: ReadTrackingReport;
    thread?: MessageView[];
}

export interface TermRow {
    clause?: string;
    termNo?: number;
    facet?: string;
    matchKey?: string;
}

export interface ReadTrackingReport {
    messageId?: string;
    subject?: string;
    publishedAt?: string;
    dueAt?: string | undefined;
    requiresAcknowledgement?: boolean;
    audienceAtPublish?: number;
    audienceNow?: number;
    denominatorSource?: string;
    deliveredCount?: number;
    readCount?: number;
    acknowledgedCount?: number;
    dismissedCount?: number;
    unreadCount?: number;
    recipients?: RecipientState[];
    note?: string | undefined;
}

export interface RecipientState {
    partyKey?: string;
    partyName?: string;
    state?: string;
    occurredAt?: string | undefined;
    channel?: string | undefined;
    dismissed?: boolean;
    stillInAudience?: boolean;
}

export interface MessageView {
    id?: string;
    sequence?: number;
    stream?: string;
    subject?: string;
    occurredAt?: string;
    publishedAt?: string;
    expiresAt?: string | undefined;
    dueAt?: string | undefined;
    severity?: string;
    flags?: string[];
    pinnedUntil?: string | undefined;
    requiresAcknowledgement?: boolean;
    allowsReply?: boolean;
    myState?: string | undefined;
    isOverdue?: boolean;
    payload?: string | undefined;
    presentation?: Presentation | undefined;
    correlationId?: string;
    causationId?: string | undefined;
    producer?: ProducerRef;
}

export interface ProducerRef {
    partyKey?: string | undefined;
    name?: string;
}

export interface ReceiptRequest {
    state?: string;
}

export interface ReplyRequest {
    presentation?: Presentation;
}

export interface InboxResponse {
    messages?: MessageView[];
    watermark?: number;
}

export interface CursorResponse {
    messages?: MessageView[];
    position?: number;
    watermark?: number;
}

export interface CommitCursorRequest {
    sequence?: number;
}

export interface PartySummary {
    id?: string;
    key?: string;
    type?: string;
    name?: string;
    externalId?: string | undefined;
    nodeKey?: string | undefined;
    isActive?: boolean;
    channels?: string[];
    attributes?: { [key: string]: string[]; };
    updatedAt?: string;
}

export interface UpsertPartyRequest {
    key?: string;
    type?: string;
    name?: string;
    externalId?: string | undefined;
    nodeKey?: string | undefined;
    channels?: string[];
    attributes?: { [key: string]: string[]; };
}

export interface SetPartyNodeRequest {
    nodeKey?: string | undefined;
}

export interface UpsertAttributeDefinitionRequest {
    key?: string;
    displayName?: string;
    dataType?: string;
    cardinality?: string;
    allowedValues?: string[] | undefined;
    isFilterable?: boolean;
    description?: string | undefined;
    source?: string;
    sourceSystem?: string | undefined;
    stalenessThresholdSeconds?: number | undefined;
}

export interface PrincipalSummary {
    id?: string;
    type?: string;
    name?: string;
    email?: string | undefined;
    partyId?: string | undefined;
    partyKey?: string | undefined;
    partyName?: string | undefined;
    maxAudienceScope?: string;
    isActive?: boolean;
    createdAt?: string;
    lastAuthenticatedAt?: string | undefined;
    moduleLevels?: { [key: string]: string; };
    grants?: GrantRef[];
    audienceGroups?: string[];
}

export interface CreateUserRequest {
    name?: string;
    email?: string;
    password?: string;
    maxAudienceScope?: string;
    partyKey?: string | undefined;
    streams?: string[] | undefined;
}

export interface SetPrincipalPartyRequest {
    partyKey?: string | undefined;
    createIfMissing?: boolean;
    streams?: string[] | undefined;
}

export interface InboxBinding {
    partyKey?: string | undefined;
    partyName?: string | undefined;
    channel?: string;
    streams?: string[];
}

export interface SetModuleAccessRequest {
    level?: string;
}

export interface SetActiveRequest {
    isActive?: boolean;
}

export interface SetGrantsRequest {
    grants?: GrantInput[];
}

export interface GrantInput {
    pattern?: string;
    publish?: boolean;
    subscribe?: boolean;
}

export interface SetAudienceScopeRequest {
    maxAudienceScope?: string;
    audienceGroups?: string[];
}

export interface ApiKeySummary {
    id?: string;
    principalId?: string;
    principalName?: string;
    label?: string | undefined;
    keyId?: string;
    displayHint?: string;
    partyId?: string | undefined;
    partyKey?: string | undefined;
    channel?: string | undefined;
    streams?: string[];
    mode?: string;
    createdAt?: string;
    expiresAt?: string | undefined;
    revokedAt?: string | undefined;
    lastUsedAt?: string | undefined;
    isActive?: boolean;
}

export interface CreatedApiKey {
    key?: ApiKeySummary;
    fullValue?: string;
}

export interface CreateApiKeyRequest {
    label?: string;
    partyKey?: string;
    channel?: string;
    streams?: string[];
    mode?: string;
    subjectFilter?: string | undefined;
    maxAudienceScope?: string;
    grants?: GrantInput[];
    expiresAt?: string | undefined;
}

export interface RotateApiKeyRequest {
    overlapHours?: number;
}

export interface TenantSummary {
    id?: string;
    key?: string;
    name?: string;
    isActive?: boolean;
    createdAt?: string;
    partyCount?: number;
}

export interface CreatedTenant {
    tenant?: TenantSummary;
    adminPrincipalId?: string;
    adminEmail?: string;
}

export interface CreateTenantRequest {
    key?: string;
    name?: string;
    adminName?: string;
    adminEmail?: string;
    adminPassword?: string;
}

export interface StreamSummary {
    id?: string;
    key?: string;
    name?: string;
    description?: string | undefined;
    ownerScope?: string;
    lastSequence?: number;
    retentionDays?: number | undefined;
    isActive?: boolean;
    subjects?: SubjectSummary[];
}

export interface SubjectSummary {
    id?: string;
    subject?: string;
    policy?: string;
    jsonSchema?: string | undefined;
    description?: string | undefined;
}

export interface UpsertStreamRequest {
    key?: string;
    name?: string;
    description?: string | undefined;
    retentionDays?: number | undefined;
}

export interface UpsertSubjectRequest {
    subject?: string;
    policy?: string;
    jsonSchema?: string | undefined;
    description?: string | undefined;
}

export interface FlagAdminSummary {
    key?: string;
    displayName?: string;
    colorHint?: string | undefined;
    description?: string | undefined;
    isPlatform?: boolean;
    messageCount?: number;
}

export interface UpsertFlagRequest {
    displayName?: string;
    colorHint?: string | undefined;
    description?: string | undefined;
}

export interface SubscriptionSummary {
    id?: string;
    principalId?: string;
    principalName?: string;
    principalType?: string;
    principalIsActive?: boolean;
    partyKey?: string | undefined;
    partyName?: string | undefined;
    channel?: string;
    mode?: string;
    streamKey?: string;
    subjectFilter?: string | undefined;
    isMandatory?: boolean;
    isActive?: boolean;
    cursorPosition?: number | undefined;
    streamHead?: number;
    createdAt?: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/**
 * The base every generated client extends. It exists for one reason: the bearer token and the
 * canonical 401/403 handling belong in ONE place, not repeated at 43 call sites.
 *
 * Hand-written HTTP calls are banned in this project (§1.3); the generated client is the only way
 * the console talks to the API, so this is the only file that knows fetch exists.
 */